<template>
    <div class="performance-box">
        <div class="performance-box-bg">
            <a href="#add"><el-button>立即咨询</el-button></a>
            <div class="performance-box-common performance-box-infor">
                <h3>专业介绍</h3>
                <p>表演专业属于一级艺术学科，旨在培养具有一定的马克思主义基本理论素养，并具备和掌握表演艺术的基本理论和基本技巧，能够在戏剧、戏曲、电影、电视和舞蹈等表演中独立完成不同人物形象创作的高级专门人才。<br> 表演，著作权法术语，指演奏乐曲、上演剧本、朗诵诗词等直接或者借助技术设备以声音、表情、动作公开再现作品。</p>
            </div>
        </div> 
        <div class="performance-box-work performance-box-common performance-box-common1">
            <h3>就业方向</h3>
            <el-row type="flex" justify="space-between" class="performance-box-work-list">
                <el-col v-for="(item,index) in workList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="performance-box-tiao performance-box-common performance-box-common1">
            <h3>报考条件</h3>
            <h4>对专业感兴趣，有专研深入发展兴趣专业的决心，还要坚持学习</h4>  
            <el-row class="performance-box-tiao-content">
                <el-col :span="6" v-for="(item,index) in tiaoList" :key="index">
                    <img :src="item.src" alt="">
                    <div class="performance-box-tiao-item">
                        <h4>{{item.title}}</h4>
                        <p>{{item.desc}}</p>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="performance-box-test performance-box-common performance-box-common1">
            <h3>考试内容</h3>
            <el-row class="performance-box-test-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in testList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.title}}</h5>
                    <p>{{item.desc}}</p>
                </el-col>
            </el-row>
        </div>
        <div class="performance-box-subject performance-box-common performance-box-common1">
            <h3>学习科目</h3>
            <h4>表演基础理论、表演基本技能、表演剧目、艺术理论、文学修养课程</h4>
            <el-row class="performance-box-subject-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in subjectList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="performance-box-tips performance-box-common performance-box-common1">
            <h3>考试流程</h3>
            <el-row class="performance-box-tips-content" type="flex" justify="space-between">
                <el-col class="performance-box-tips-item1">
                    <h4>初试</h4>
                    <div>
                        考试科目为声乐、台词、形体
                    </div>
                </el-col>
                <el-col class="performance-box-tips-item2">
                    <h4>复试</h4>
                    <div>考试科目为命题即兴表演</div>
                </el-col>
                <el-col class="performance-box-tips-item3">
                    <h4>三试</h4>
                    <div>考试科目为表演综合测试</div>
                </el-col>
            </el-row>
            <el-row class="performance-box-tips-content1">
                <h5>补充说明：</h5>
                <p>(一）考生一律穿平底鞋参加考试。(二）考生一律不许化妆、不允许着裙装、不许戴美瞳。(三）进入三试的考生，应准备好深色的练功服。</p>   
            </el-row>
        </div>
        <div class="performance-box-school performance-box-common performance-box-common1">
            <h3>推荐院校</h3>
            <el-row class="performance-box-school-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in schoolList" :key="index">
                    <el-row type="flex">
                        <el-col :span="6">
                            <img :src="item.src" alt="">
                        </el-col>
                        <el-col :span="18">
                            <div>{{item.desc}}</div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div class="performance-box-order" id="add">
            <div class="performance-box-order-content performance-box-common performance-box-common1">
                <h3>提交咨询表</h3>
                <h4>填写信息后，可以查询更多艺考信息</h4>
                <el-row>
                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="phone">
                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item label="专业：" prop="major">
                            <el-input v-model="formInline.major" placeholder="请输入专业"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                        </el-form>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        const validateMajor = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入专业"));
            } else {
                callback();
            }
        };
        return {
            workList:[
                {src:require('../../assets/images/performance-work-icon1.png'),desc:'文艺团体'},
                {src:require('../../assets/images/performance-work-icon2.png'),desc:'电视台'},
                {src:require('../../assets/images/performance-work-icon3.png'),desc:'电影厂'},
                {src:require('../../assets/images/performance-work-icon4.png'),desc:'影视制作公司'},
                {src:require('../../assets/images/performance-work-icon5.png'),desc:'文化管理机构'},
                {src:require('../../assets/images/performance-work-icon6.png'),desc:'宣传文教部'},
                {src:require('../../assets/images/performance-work-icon7.png'),desc:'教学科研'},
                {src:require('../../assets/images/performance-work-icon8.png'),desc:'影视表演'},
            ],
            tiaoList:[
                {src:require('../../assets/images/performance-tiao-icon1.png'),desc:'视力经矫正4.8以上,无色盲、色弱',title:'视力'},
                {src:require('../../assets/images/performance-tiao-icon2.png'),desc:'男172cm、女160cm',title:'身高'},
                {src:require('../../assets/images/performance-tiao-icon3.png'),desc:'身体健康，无生理缺陷，动作协调',title:'肢体'},
                {src:require('../../assets/images/performance-tiao-icon4.png'),desc:'五官端正，口齿清楚，会讲较好的普通话',title:'语言'},
            ],
            testList:[
                {src:require('../../assets/images/performance-test-icon1.png'),desc:'基本形态和基本件的考察、一般造型练习模仿动作练习、综合练习',title:'形体'},
                {src:require('../../assets/images/performance-test-icon2.png'),desc:'正音练习、感觉练习即兴练习、强弱声练习',title:'台词'},
                {src:require('../../assets/images/performance-test-icon3.png'),desc:'音准、节奏、模仿节奏练习、音阶、和声的练习',title:'声乐'},
                {src:require('../../assets/images/performance-test-icon4.png'),desc:'表演以道具命题的练习、单人小品、双人小品、多人小品、根据地点的命题小品感觉练习、一句话的练习',title:'表演'},
            ],
            subjectList:[
                {src:require('../../assets/images/performance-subject-icon1.png'),desc:'表演'},
                {src:require('../../assets/images/performance-subject-icon2.png'),desc:'台词'},
                {src:require('../../assets/images/performance-subject-icon3.png'),desc:'声乐'},
                {src:require('../../assets/images/performance-subject-icon4.png'),desc:'形体'},
                {src:require('../../assets/images/performance-subject-icon5.png'),desc:'才艺展示'},
                {src:require('../../assets/images/performance-subject-icon6.png'),desc:'面试技巧'},
                {src:require('../../assets/images/performance-subject-icon7.png'),desc:'文艺常识'},
                {src:require('../../assets/images/performance-subject-icon8.png'),desc:'自我介绍'},
            ],
            schoolList:[
                {src:require('../../assets/images/director-school-icon3.jpg'),desc:'北京电影学院'},
                {src:require('../../assets/images/director-school-icon5.jpg'),desc:'上海戏剧学院'},
                {src:require('../../assets/images/performance-school-icon1.png'),desc:'中国戏曲学院'},
                {src:require('../../assets/images/performance-school-icon2.png'),desc:'南京艺术学院'},
                {src:require('../../assets/images/director-school-icon2.jpg'),desc:'浙江传媒学院'},
                {src:require('../../assets/images/director-school-icon4.jpg'),desc:'中国戏剧学院'},
                {src:require('../../assets/images/director-school-icon1.jpg'),desc:'中国传媒大学'},
                {src:require('../../assets/images/performance-school-icon3.png'),desc:'山东艺术学院'},
                {src:require('../../assets/images/performance-school-icon4.png'),desc:'中国联合大学复旦 大学'},
                {src:require('../../assets/images/performance-school-icon5.png'),desc:'武汉大学'},
                {src:require('../../assets/images/director-school-icon8.jpg'),desc:'四川大学'},
                {src:require('../../assets/images/performance-school-icon6.png'),desc:'四川师范大学'},

            ],
            formInline: {
                username: '',
                phone: '',
                major: '',
                type: '9'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
                major: [
                    { trigger: 'blur', validator: validateMajor },
                ],
            }
        };
    },
    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
$font-family: 'MicrosoftYaHei';
$width: 1200px;
$margin: 0 auto;
.performance-box-common {
    padding-top: 62px;
    box-sizing: border-box;
    h3 {
        font-size: 36px;
        font-family: $font-family;
        font-weight: 700;
        text-align: center;
        color: #332e2c;
        line-height: 47px;
        letter-spacing: 3.6px;
        margin: 0;
    }
}
.performance-box-common1 {
    >h4 {
        font-size: 18px;
        font-family: $font-family;
        font-weight: 400;
        text-align: center;
        color: #999999;
        line-height: 24px;
        margin: 24px 0 62px 0;
    }
}
.performance-box-bg {
    background: url('../../assets/images/performance-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 644px;
    button {
        width: 136px;
        height: 50px;
        background: rgba(255,255,255,0.20)!important;
        border: 1px solid #ffffff!important;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        position: relative;
        left: calc(50% - 600px);
        top: 320px;
    }
    button:hover {
        background: rgba(255,255,255,0)!important;
    }
}
.performance-box-infor {
    width: $width;
    margin: $margin;
    height: 285px;
    background: rgba(255,255,255,0.90);
    border-radius: 20px;
    box-shadow: 0px 4px 20px 0px rgba(143,43,0,0.12), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
    backdrop-filter: blur(4px);
    padding: 44px 58px;
    margin-top: 400px;
    p {
        font-size: 20px;
        font-family: $font-family;
        font-weight: 400;
        color: #2c3331;
        line-height: 38px;
        margin-top: 36px;
    }
}
.performance-box-work {
    padding-top: 160px;
    height: 514px;
    background: #f5f7fa;
    box-sizing: border-box;
    .performance-box-work-list {
        width: $width;
        margin: $margin;
        margin-top: 62px;
    }
    .el-col {
        width: 130px;
        text-align: center;
        h5 {
            margin-top: 20px;
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            text-align: center;
            color: #2c3331;
            line-height: 26px;
        }
    }
}
.performance-box-tiao {
    height: 568px;
    background: linear-gradient(180deg,#3f3a37, #211d1b 99%);
    position: relative;
    h3 {
        color: #ffffff;
    }
    h4 {
        margin-top: 20px;
    }
    .performance-box-tiao-content {
        width: $width;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
        .el-col {
            position: relative;
        }
        .performance-box-tiao-item {
            width: 260px;
            height: 170px;
            background: rgba(19,0,156,0.10);
            border: 1px solid rgba(255,255,255,0.18);
            border-radius: 8px;
            backdrop-filter: blur(3px);
            padding: 24px 20px;
            box-sizing: border-box;
            position: absolute;
            bottom: 20px;
            left: 20px;
            h4 {
                font-size: 26px;
                font-family: $font-family;
                font-weight: 700;
                text-align: center;
                color: #ffffff;
                line-height: 38px;
                margin: 0;
                margin-bottom: 20px;
            }
            p {
                font-size: 18px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 32px;
                margin: 0;
            }
        }
    }
}
.performance-box-test {
    background: url('../../assets/images/common-test.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 597px;
    .performance-box-test-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        margin-top: 62px;
        .el-col {
            width: 265px;
            h5 {
                font-size: 26px;
                font-family: $font-family;
                font-weight: 700;
                text-align: center;
                color: #332e2c;
                line-height: 35px;
                margin:13px 0 18px 0;
            }
            p {
                font-size: 18px;
                font-family: $font-family;
                font-weight: 400;
                text-align: left;
                color: #66605e;
                line-height: 32px;
                margin:0;
            }
        }
    }
}
.performance-box-subject {
    width: 100%;
    height: 627px;
    background: #563eff;
    h3 {
        color: #fff;
    }
    h4 {
        color: rgba(255,255,255,0.60);
    }
    .performance-box-subject-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        .el-col {
            width: 25%;
            text-align: center;
            h5 {
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 26px;
                margin: 20px 0 60px 0;
            }
        }
    }
}
.performance-box-tips {
    width: 100%;
    height: 497px;
    background: #ffff;
    .performance-box-tips-content {
        width: $width;
        margin: $margin;
        margin-top: 48px;
        .el-col {
            width: 380px;
            height: 153px;
            border-radius: 8px;
            padding: 30px 32px;
            box-sizing: border-box; 
            h4 {
                font-size: 28px;
                font-family: $font-family;
                font-weight: 700;
                color: #2c3331;
                margin: 0;
                margin-bottom: 2px;
                line-height: 37px;
            }
            div {
                margin-top: 26px;
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                color: #2c3331;
                line-height: 26px;
                position: relative;
            }
            span {
                display: inline-block;
                width: 71%;
                margin-left: 82px;
            }
            .performance-box-tips-count {
                width: 74px;
                height: 30px;
                background: #348aff;
                border-radius: 5px;
                font-size: 16px;
                font-family: $font-family;
                font-weight: 400;
                color: #ffffff;
                line-height: 30px;
                text-align: center;
                margin-right: 10px;
                position: absolute;
                top: 0;
                margin-left: 0;
                
            }
        }
        .performance-box-tips-item1 {
            background: #ecf4ff;
            border: 1px solid #b3d3ff;
        }
        .performance-box-tips-item2 {
            background: #fff4eb;
            border: 1px solid #ffdbbd;
        }
        .performance-box-tips-item3 {
            background: #f2f7e7;
            border: 1px solid #c4de89;
        }
    }
    h5 {
        font-size: 22px;
        font-family: $font-family;
        font-weight: 700;
        color: #ff7c26;
        line-height: 40px;
        margin: 0;
        margin-top: 40px;
    }
    p {
        font-size: 18px;
        font-family: $font-family;
        color: #ff7c26;
        line-height: 34px;
        margin: 0;
    }
    .performance-box-tips-content1 {
        margin: $margin;
        width: $width;
    }
}
.performance-box-school {
    height: 590px;
    background: url('../../assets/images/director-school-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    h3 {
        color: #fff;
    }
    .performance-box-school-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        .el-col-24 {
            padding:16px 12px;
            width: 265px;
            height: 88px;
            background: #ffffff;
            border-radius: 8px;
            margin-top: 48px;
            .el-row {
                justify-content: center;
                align-items: center;
            }
            .el-col-18 {
                display: inline-block;
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                color: #2c3331;
                padding-left: 6px;
            }
        }
    }
}
.performance-box-order {
    background: url('../../assets/images/common-bg.png') no-repeat;
    background-size: cover;
    background-color: #563eff;
    height: 359px;
    margin-bottom: -56px;
    h3 {
        color: #fff;
    }
    h4 {
        color: rgba(255,255,255,0.60);
        margin-bottom: 55px;
        
    }
    .performance-box-order-content {
        width: $width;
        margin: $margin;
        .order-form-inline {
            margin-top: 0;
        }
        span {
            display: inline-block;
        }
        img {
            position: absolute;
            top:0;
            left: 0;
        }
        .performance-box-order-title {
            font-size: 36px;
            font-family: 'zihun443hao';
            color: #ffffff;
        }
        .performance-box-order-desc {
            font-size: 18px;
            font-weight: 500;
            color: #ffffff;
            margin-left: 24px;
        }
    }
}
</style>